import { defineStyleConfig } from '@chakra-ui/react';

export const buttonTheme = defineStyleConfig({
  baseStyle: {
    p: 10,
    borderRadius: 30
  },
  sizes: {
    md: {
      px: 10,
      fontSize: '19px',
      fontWeight: '700',
      fontFamily: 'DINNextLTProBold'
    },
    slim: {
      py: 5
    }
  },
  variants: {
    whiteToGreen: () => ({
      backgroundColor: 'white',
      shadow: 'md',
      whiteSpace: 'normal',
      color: 'blue.500',
      _hover: {
        color: 'black'
      },
      _active: {
        backgroundColor: 'green',
        color: 'white'
      }
    }),
    outline: (props) => ({
      borderWidth: '2px',
      ...(props.colorScheme === 'blue' && {
        _hover: {
          borderWidth: '2px',
          borderStyle: 'solid',
          bg: 'blue.500',
          color: 'white'
        }
      })
    }),
    solid: (props) => ({
      ...(props.colorScheme === 'gray' && {
        _hover: {
          bg: 'blue.500',
          color: 'white'
        }
      })
    }),
    link: () => ({
      ...{
        ps: 0,
        pe: 0
      }
    })
  }
});
